import React, {ReactNode} from 'react';

import {Menu} from '@reach/menu-button';

import '@reach/menu-button/styles.css';
import {ReactComponent as ArrowDownIcon} from '../../../assets/svg/arrow-bottom.svg';
import {ReactComponent as ArrowUpIcon} from '../../../assets/svg/arrow-up.svg';

import {List, Item, CustomButton, CustomMenuButton, CustomIcon, CustomButtonDiv} from './styled';

interface Props {
    children: ReactNode;
    label: string;
    width?: string | number;
    noIcon?: boolean;
}

export class DropdownMenu extends React.Component<Props> {
    public static List = List;

    public static Item = Item;

    render() {
        const {children, label, width, noIcon = false} = this.props;

        const styledChildren = React.Children.map(children, (child) => {
            if (React.isValidElement(child) && child.type === List) {
                return React.cloneElement(child, {
                    style: {width, ...(child.props.style || {})},
                } as any);
            }
            return child;
        });

        return (
            <Menu>
                {({isExpanded}) => (
                    <>
                        <CustomMenuButton>
                            {noIcon ? (
                                <CustomButtonDiv
                                    isExpanded={isExpanded}
                                    style={{whiteSpace: 'nowrap'}}
                                >
                                    {label}
                                </CustomButtonDiv>
                            ) : (
                                <CustomButton
                                    isExpanded={isExpanded}
                                    style={{whiteSpace: 'nowrap'}}
                                >
                                    {label}
                                    <CustomIcon
                                        source={isExpanded ? ArrowUpIcon : ArrowDownIcon}
                                        width={14}
                                        height={14}
                                    />
                                </CustomButton>
                            )}
                        </CustomMenuButton>
                        {styledChildren}
                    </>
                )}
            </Menu>
        );
    }
}
